import { create } from 'zustand'
import type { Task } from '@/types'

interface TaskFilters {
  category?: string
  minBudget?: number
  maxBudget?: number
  status?: string
}

interface TaskStore {
  tasks: Task[]
  filters: TaskFilters
  currentTask: Task | null
  setTasks: (tasks: Task[]) => void
  addTask: (task: Task) => void
  updateTask: (id: string, updates: Partial<Task>) => void
  setFilters: (filters: TaskFilters) => void
  clearFilters: () => void
  setCurrentTask: (task: Task | null) => void
}

export function useTaskStore(): TaskStore {
  return create<TaskStore>((set) => ({
    tasks: [],
    filters: {},
    currentTask: null,
    setTasks: (tasks) => set({ tasks }),
    addTask: (task) =>
      set((state) => ({ tasks: [task, ...state.tasks] })),
    updateTask: (id, updates) =>
      set((state) => ({
        tasks: state.tasks.map((t) => (t.id === id ? { ...t, ...updates } : t)),
        currentTask:
          state.currentTask?.id === id
            ? { ...state.currentTask, ...updates }
            : state.currentTask,
      })),
    setFilters: (filters) => set({ filters }),
    clearFilters: () => set({ filters: {} }),
    setCurrentTask: (currentTask) => set({ currentTask }),
  }))
}
